import React, { useEffect } from "react";
import NavigationBar from "./topNavigation/components/NavigationBar.fetcher";
import { ToastContainer } from "react-toastify";
import { SideMenu } from "./sideNavigation/components/SideMenu.fetcher.ui";
import { useLocation, useNavigate } from "react-router-dom";
import UnAuthorizedLayout from "./UnAuthorizedLayout";
import { useCurrentUserProfile } from "@/store/auth/userProfile.store";
import { brand } from "branchAndBrandSpecific/utils/brandVariables/brandVariables";
import { siteRoutes } from "@/routes/siteRoutesList";
import Consent from "@/components/Consent/Consent";
import { useAtomValue } from "jotai";
import { clientAtom } from "@/utils/atoms/atomClient";
import { Box, Container, Flex } from "@radix-ui/themes";
import Footer from "./Footer/Footer";
import { PickerWinnerPopupFetcher } from "../features/picked-winner-popup/picker-winner-popup.fetcher";
export default function Layout({ children }: { children: React.ReactNode }) {
  const noSideMenu = false;
  const location = useLocation();
  const navigate = useNavigate();
  const currentUser = useCurrentUserProfile((s) => s.user);
  // IN CASE OF SIGN UP 3 OR OTHER SIGN UP PAGES, ADD HERE | WILL REMOVE SIDEBAR AND FIX SCSS
  if (location.pathname === "/signup-success") {
    return <UnAuthorizedLayout>{children}</UnAuthorizedLayout>;
  }
  const currentClient = useAtomValue(clientAtom);
  // Set the theme of the current user on page load/refresh
  useEffect(() => {
    // Scroll to the top of the window

    if (brand.hasFeature.themes) {
      document.documentElement.className = `theme-${currentUser.theme}`;
    } else {
      document.documentElement.className = `theme-${brand.brandTheme}`;
    }
    if (document.body.classList.contains("landing-bg")) {
      document.body.classList.remove("landing-bg");
    }

    if (
      (window.location.pathname === "/" ||
        window.location.pathname === "/landing") &&
      currentUser
    ) {
      navigate(siteRoutes["home"]);
    }
  }, [currentUser]);

  useEffect(() => {
    if (currentClient !== "") {
      document.documentElement.className = `theme-${currentClient}`;
    } else {
      document.documentElement.className = `theme-${brand.brandTheme}`;
    }
  }, [currentClient]);

  return (
    <>
      {!noSideMenu && (
        <>
          <SideMenu currentViewName={location.pathname} />
          <PickerWinnerPopupFetcher />
          <Box pl={{ initial: "0", sm: "300px" }} minHeight="100vh">
            <Flex direction="column" minHeight="100vh">
              <NavigationBar />
              <Box flexGrow="1">
                <Container px={{ initial: "4", md: "2", xl: "0" }}>
                  {children}
                </Container>
              </Box>
              <Footer />
            </Flex>
            <ToastContainer
              position="bottom-right"
              autoClose={3000}
              hideProgressBar={false}
              newestOnTop={false}
              closeOnClick
              rtl={false}
              pauseOnFocusLoss={false}
              draggable
              pauseOnHover={false}
              theme="dark"
              limit={3}
            />
          </Box>
        </>
      )}
      <Consent
        layout={brand.brandValue === "ELGIGANTEN" ? "small" : "default"}
      />
    </>
  );
}
